import React from 'react';
import OverviewLayout from 'components/OverviewLayout/OverviewLayout';
import { Button, Link, Spinner, Typography } from 'ui-kit';
import { Table } from 'antd';
import { formatCurrency } from 'utils';
import './RequestList.scss';
import { useOrderProductNeedApproval } from 'api/order_product_sdk';
import { useSignedUser } from 'api/auth';

export default function RequestList() {
  const { data: user } = useSignedUser();
  const { data: orderProducts, isLoading: isLoadingOrderProducts } = useOrderProductNeedApproval({
    ownerId: user?.owner_id,
  });

  if (isLoadingOrderProducts) {
    return (
      <OverviewLayout>
        <Spinner />
      </OverviewLayout>
    );
  }

  return (
    <OverviewLayout>
      {orderProducts && orderProducts.length === 0 && (
        <div className="RequestList_body">
          <Typography variant="body1" className="RequestList_message">
            You don&apos;t have any pending requests at this time.
          </Typography>
        </div>
      )}
      {orderProducts.length > 0 && (
        <Table
          className="RequestList_table"
          dataSource={orderProducts}
          scroll={{ x: 500 }}
          columns={[
            {
              title: 'Product',
              dataIndex: 'product_name',
              key: 'product_name',
              render: (text, record) => (
                <>
                  <div>
                    <Link href={`/owner/${record.owner_purchase_uuid}/?showPrices=True`}>
                      {text}
                    </Link>
                  </div>
                  {record.is_purchasable_off_platform && (
                    <Typography variant="caption" color="secondary">
                      Pay via Airbnb Resolution Center
                    </Typography>
                  )}
                </>
              ),
            },
            {
              title: 'Store Name',
              dataIndex: 'store_name',
              key: 'store_name',
              render: (text) => (
                <Typography variant="body1" color="secondary">
                  {text}
                </Typography>
              ),
            },
            {
              title: 'Guest',
              dataIndex: 'guest',
              key: 'guest_name',
              render: (text, record) => (
                <Typography variant="body1" color="secondary">
                  {record.guest.guest_name}
                </Typography>
              ),
            },
            {
              title: 'Amount',
              dataIndex: 'guest_amount',
              key: 'guest_amount',
              render: (text, record) => (
                <Typography variant="body1" color="secondary">
                  {formatCurrency(text, record.currency)}
                </Typography>
              ),
            },
            {
              title: 'Your Profit',
              dataIndex: 'owner_profit',
              key: 'owner_profit',
              render: (text, record) => (
                <Typography variant="body1" color="secondary">
                  {formatCurrency(text, record.currency)}
                </Typography>
              ),
            },
            {
              dataIndex: 'owner_purchase_uuid',
              key: 'owner_purchase_uuid',
              render: (text) => (
                <Button variant="outlined" href={`/owner/${text}/?showPrices=True`}>
                  Manage
                </Button>
              ),
            },
          ]}
        />
      )}
    </OverviewLayout>
  );
}
